// NOTE: esbuild移行の一環として、過去の仕様をそのままコピペしているため、
// esbuild移行時に命名やimportできるようにリファクタリング必要

// TODO: 必要に応じてパフォーマンスの改善も行う
// https://github.com/activo-inc/activo/pull/3022#discussion_r2303470980

function articlesMenuNavigate(navLinkSelector = '.articlesMenu li a') {
  // NOTE: アンカー先セクションが無いリンクは除外（未実装セクションで offset() が落ちないように）
  const navLink = $(navLinkSelector).filter(function() {
    return $($(this).attr('href')).length > 0;
  });
  if (!navLink[0]) {
    return false;
  }
  // 見出しを配列に格納
  const contentsArr = [];
  for (let i = 0; i < navLink.length; i += 1) {
    // 見出しを取得
    const targetContents = $(navLink.eq(i).attr("href"));
    // 配列に格納
    contentsArr[i] = targetContents;
  }
  // ページ読み込み時とスクロール時に、現在地をチェックする
  $(window).on("load scroll", () => {
    navLink.removeClass("current");
    // 現在のスクロール位置を取得
    const windowScrolltop = $(window).scrollTop() + 80;
    for (let i = 0; i < contentsArr.length; i += 1) {
      // 現在のスクロール位置が、見出しと次の見出しの間にあるものを調べる
      var isCorrectNavigation;
      if (i < contentsArr.length - 1) {
        isCorrectNavigation =
          contentsArr[i].offset().top <= windowScrolltop &&
          contentsArr[i + 1].offset().top > windowScrolltop;
      } else if (i === contentsArr.length - 1) {
        isCorrectNavigation = contentsArr[i].offset().top <= windowScrolltop;
      }
      if (isCorrectNavigation) {
        // ナビゲーションにclass="current"をつける
        navLink.eq(i).addClass("current");
      }
    }
  });
}

// NOTE: esbuild はモジュールレベルの副作用がない純粋な関数宣言をバンドルから除外する
// Sprockets からの移行のため、グローバルアクセスを維持するために window に公開する

export default articlesMenuNavigate;
